<template>
  <div class="col-sm-8 col-md-8">
    <div class="row-col">
      <div class="row-row">
        <div class="row-body">
          <div class="row-inner">
            <div class="padding">
              <!-- fields -->
              <div 
                v-if="hasOutlet" 
                class="form-horizontal">

                <h5 class="_300 margin">{{ outlet.name }}</h5>
               
                <div 
                  v-for="target in targetList" 
                  :key="target.id" 
                  :class="{'has-error':errors.has(target.name)}" 
                  class="form-group row">
                  <label class="col-sm-4 form-control-label">{{ target.name }}</label>
                  <div class="col-sm-8">
                    <input 
                      v-validate="'required|decimal:2'" 
                      :disabled="loading"
                      :name="target.name"
                      v-model="target.target_value"
                      type="text" 
                      class="form-control" 
                      placeholder="0.00">
                    <span 
                      v-show="errors.has(target.name)"
                      class="form-error-msg">{{ errors.first(target.name) }}
                    </span>
                  </div>
                </div>

                <button 
                  :disabled="loading" 
                  class="md-btn md-raised m-b-sm w-xs green pull-right" 
                  @click="submit">Save</button>

                <div class="clearfix"/>
             
              </div>

              <p 
                v-else 
                class="text-center m-t-md">
                <i>Select any outlet in the list to set monthly target sales</i>
              </p>
              <!-- / fields -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    props: {
        outlet: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            targetList: [],
            loading: false,
        };
    },

    computed: {
        hasOutlet() {
            return !_.isEmpty(this.outlet);
        },
    },
    watch: {
        outlet() {
            if (this.outlet) {
                this.getOutletTarget();
            }
        },
    },
    created() {
        this.getTargetList();
    },
    methods: {
        getOutletTarget() {
            this.loading = true;
            let api = Laroute.route(
                'franchise.setting.outlet.getOutletTarget',
                { outlet_id: this.outlet.id },
            );

            this.$http.get(api).then(res => {
                let data = res.data.data;
                if (!_.isEmpty(data)) {
                    this.setInputValue(data);
                } else {
                    this.resetInputValue(this.targetList);
                }

                this.loading = false;
            });
        },

        submit() {
            this.loading = true;
            this.$validator.validateAll().then(success => {
                if (success) {
                    let api = Laroute.route(
                        'franchise.setting.outlet.saveOutletTarget',
                        { outlet_id: this.outlet.id },
                    );
                    this.$http.post(api, this.getSubmittedValue()).then(
                        res => {
                            let data = res.data.data;
                            this.setInputValue(data);
                            this.loading = false;
                            toastr.success('Target sales updated successfully');
                        },
                        err => {
                            toastr.error(err.statusText);
                        },
                    );
                } else {
                    this.loading = false;
                }
            });
        },

        setInputValue(outletTargets) {
            this.targetList.forEach(val => {
                let outletTarget = outletTargets.filter(t => t.id == val.id);
                if (outletTarget.length) {
                    val.target_value = outletTarget[0].pivot.target_value;
                } else {
                    val.target_value = null;
                }
            });
        },

        getSubmittedValue() {
            let data = this.targetList.map(obj => {
                return { type: obj.type, target_value: obj.target_value };
            });

            return { targets: data };
        },

        resetInputValue(targetList) {
            this.targetList = targetList.map(target => {
                target.target_value = null;
                return target;
            });
        },

        getTargetList() {
            let api = Laroute.route('franchise.vue.getTargetList');
            this.$http.get(api).then(res => {
                this.resetInputValue(res.data.data);
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/target/outlet-target-form.vue